/* VitaFresh Warenkorb: reine Entscheidungen, ohne DOM (Node-testbar, Tests: tests/vf-warenkorb.test.js).
   Genutzt von assets/vf-warenkorb.js (Empfehlungen im Mini-Warenkorb und auf /cart, Warenkorb leeren,
   Termin-Karte im Kasten «Deine Bestellung»). Regeln (Pasci 12.10.2026):
   - Empfehlungen: Unter CHF 200 Warenwert 3 Gerichte und die Karte «Extras», ab CHF 200 3 Extras und 1 Gericht.
     Im Mini-Warenkorb nur Gerichte (4 Zeilen, nie Extras).
   - Gerichte (Pasci 21.10.2026, Kundentest): in der Reihenfolge der von Hand sortierten Kollektion «Warenkorb-Empfehlungen»
     (Handle warenkorb-empfehlungen), was schon im Warenkorb liegt, fällt weg. Reichen sie nicht, füllen die Bestseller von
     «Alle Hauptgerichte» auf (ebenfalls in ihrer Reihenfolge); fehlt die Kollektion, sind die Bestseller der ganze Vorrat.
     Nie nach Preis. Die Marke «damit 10 %» bleibt ein kleiner Hinweis, sie ändert die Reihenfolge nicht. Keine Rotation.
   - Profil aus dem Warenkorb (Pasci 22.10.2026): Merkmale der Gerichte im Warenkorb (Tags, nur Gerichte mit Tag «hauptgerichte»).
     Harte Regeln: alles vegan → nur Vegan; alles vegetarisch oder vegan → nur Vegetarisches (Tag vegi/vegan, also nie Fleisch oder Fisch);
     alles low-carb oder keto → nur Low-Carb/Keto (nie High-Carb, auch kein Gericht ohne Kohlenhydrat-Tag). Gilt eine harte Regel oder
     gehören alle Gerichte zur selben Familie, ist das Profil klar: zuerst nach Anzahl gemeinsamer Merkmale (Ernährung, Ziel, Protein),
     bei Gleichstand die Reihenfolge der Kollektion. Sonst (gemischt, nur Extras): Abwechslung, je Familie das erste Gericht in der
     Reihenfolge der Kollektion, danach der Rest in dieser Reihenfolge. Familien: Vegetarisch/Vegan, Fisch, Low-Carb/Keto,
     Leicht/Abnehmen, Klassiker (der Rest, meist High-Carb mit Fleisch).
   - Grösse: die grösste Grösse, die bei Gerichten schon im Warenkorb liegt (Klein, Mittel, Gross); gibt es das
     Gericht so nicht, die nächstgrössere, sonst die grösste vorhandene; ohne Gericht im Warenkorb Mittel.
   - Warenwert = Zwischensumme der Artikel vor Rabatt inklusive Kühltasche (cart.original_total_price, Rappen).
   Preise kommen aus dem Shop (products.json), nichts wird gerechnet ausser der Summe der Zeilen. */
(function (root) {
  "use strict";

  var GROESSEN = ["Klein", "Mittel", "Gross"];
  /* Schwellen in Rappen mit dem Text auf der Karte, aus einer Quelle: Metaobjekte «Rabattstufe» über assets/vf-warenkorb-basis.js
     (20.10.2026). Die Gratis-Lieferung gilt nach Rabatt. Fehlt die Basis: keine Schwellen (Vorschläge nur nach Preis). */
  var basisNode = null;
  if (typeof module !== "undefined" && module.exports) { try { basisNode = require("./vf-warenkorb-basis.js"); } catch (e) { basisNode = null; } }
  function stufen() { var b = root.VFWarenkorbBasis || basisNode; return b ? b.lesen() : null; }
  function schwellen() {
    var k = stufen();
    if (!k) return [];
    return [{ rappen: k.gratis * 100, text: "damit Gratis-Lieferung", nachRabatt: true }].concat(k.stufen.map(function (x) {
      return { rappen: x.ab * 100, text: "damit " + x.prozent + " %" };
    }));
  }
  var EXTRAS_AB = 20000; /* Warenwert in Rappen, ab dem Extras vorne stehen */

  function rappen(preis) { /* products.json liefert "17.40" oder 17.4 */
    var n = Math.round(parseFloat(String(preis).replace(",", ".")) * 100);
    return isFinite(n) ? n : 0;
  }

  function zahl(v) { var n = parseInt(v, 10); return isFinite(n) ? n : 0; }

  /* Kundenrabatt (KMU, Familie, Wiederverkauf usw.) ist ein anderer automatischer Rabatt als die Staffel:
     dann gibt es keine Schwellen (wie im Rabatt-Balken, der sich dann ausblendet). */
  function kundenrabatt(cart) {
    var k = stufen(), titel = k ? k.titel : {};
    var apps = ((cart && cart.cart_level_discount_applications) || []).slice();
    ((cart && cart.items) || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (al) { if (al && al.discount_application) apps.push(al.discount_application); });
    });
    return apps.some(function (a) {
      return a && a.type === "automatic" && !Object.prototype.hasOwnProperty.call(titel, String(a.title || "").replace(/\s+/g, ""));
    });
  }

  /* Lage des Warenkorbs aus /cart.js. b2b: Konto mit Tag no_loyalty (keine Rabatt-Anzeige). */
  function lage(cart, b2b) {
    var vor = zahl(cart && cart.original_total_price);
    var nach = cart && cart.total_price != null ? zahl(cart.total_price) : vor;
    return { vor: vor, nach: nach, leer: !(cart && cart.item_count > 0), ohneSchwellen: !!b2b || kundenrabatt(cart) };
  }

  /* Nächste Schwelle über dem Warenwert; null, wenn alle erreicht sind. */
  function naechsteSchwelle(l) {
    if (l.ohneSchwellen) return null;
    var liste = schwellen();
    for (var i = 0; i < liste.length; i++) {
      var s = liste[i];
      if ((s.nachRabatt ? l.nach : l.vor) < s.rappen) return s;
    }
    return null;
  }

  /* Wie weit die Schwelle auf der Karte von einem Zuschlag (Rappen) erreicht wird. */
  function kreuzt(l, schwelle, preisRappen) {
    if (!schwelle) return false;
    if (schwelle.nachRabatt) {
      /* Gratis-Lieferung gilt nach Rabatt: ein neues Gericht wird mitrabattiert (z. B. WELCOME15), also im selben Verhältnis rechnen */
      var p = l.vor > 0 ? Math.round(preisRappen * l.nach / l.vor) : preisRappen;
      return l.nach + p >= schwelle.rappen;
    }
    return l.vor + preisRappen >= schwelle.rappen;
  }

  function groesseIndex(titel) { return GROESSEN.indexOf(String(titel || "").trim()); }

  /* Vorgewählte Grösse. gerichtHandles: Menge der Handles aus der Gerichte-Kollektion (nur diese zählen). Ohne diese Menge
     (Vorrat aus der kleinen Kollektion «Warenkorb-Empfehlungen») zählt jede Zeile ausser den Handles in ohne (Extras, Kühltasche);
     Grössen sind ohnehin nur «Klein», «Mittel» und «Gross». */
  function zielGroesse(items, gerichtHandles, ohne) {
    var max = -1;
    (items || []).forEach(function (i) {
      if (gerichtHandles && !gerichtHandles[i.handle]) return;
      if (!gerichtHandles && ohne && ohne[i.handle]) return;
      var g = groesseIndex(i.variant_title);
      if (g > max) max = g;
    });
    return max < 0 ? "Mittel" : GROESSEN[max];
  }

  /* Variante für eine Zielgrösse: genau diese, sonst die nächstgrössere, sonst die grösste vorhandene.
     varianten: [{id, title, price, available}]. Nur verfügbare Varianten zählen. */
  function waehleVariante(varianten, ziel) {
    var frei = (varianten || []).filter(function (v) { return v.available !== false && groesseIndex(v.title) >= 0; });
    if (!frei.length) return null;
    var z = groesseIndex(ziel);
    var exakt = frei.filter(function (v) { return groesseIndex(v.title) === z; })[0];
    if (exakt) return exakt;
    var groesser = frei.filter(function (v) { return groesseIndex(v.title) > z; })
      .sort(function (a, b) { return groesseIndex(a.title) - groesseIndex(b.title); })[0];
    if (groesser) return groesser;
    return frei.sort(function (a, b) { return groesseIndex(b.title) - groesseIndex(a.title); })[0];
  }

  /* ---- Profil aus dem Warenkorb (Pasci 22.10.2026) ---- */
  /* Tags im Shop (geprüft 22.10.2026 per Admin-API): vegetarisch heisst «vegi» («vegetarisch» kommt nicht vor, zählt aber mit), Fisch und
     Meeresfrüchte tragen «fisch-und-meeresfruchte» (drei Stoffwechsel-Gerichte «fisch-und-meeresfrüchte», manche zusätzlich «fisch»). */
  var MERKMALE = ["vegan", "low-carb", "keto", "high-carb", "high-protein", "poulet", "rind", "abnehmen", "muskelaufbau", "ausgewogen", "power"];
  var VEGI = ["vegan", "vegi", "vegetarisch"];
  var FISCH = ["fisch", "fisch-und-meeresfruchte", "fisch-und-meeresfrüchte", "allergene.fisch", "allergene.krustentiere"];
  var LOW = ["low-carb", "keto"];
  var FLEISCH = ["poulet", "rind"];
  /* Gerichte fürs Profil: nur Hauptgerichte. Zwischenmahlzeiten (Frühstück, Milchreis, Müesli; im Shop ohne «hauptgerichte», geprüft
     22.10.2026) bestimmen die Ernährung nicht und schwächen so nie eine harte Regel. */
  var GERICHT = ["hauptgerichte"];

  function tagListe(t) {
    if (typeof t === "string") t = t.split(",");
    return (t || []).map(function (x) { x = String(x).trim().toLowerCase(); return x.normalize ? x.normalize("NFC") : x; });
  }
  function hat(tags, liste) { return liste.some(function (x) { return tags.indexOf(x) >= 0; }); }

  /* Merkmale eines Gerichts: die Tags aus MERKMALE, dazu «vegi» (vegan zählt mit) und «fisch» (alle Fisch-Tags). */
  function merkmale(tags) {
    var t = tagListe(tags);
    var m = MERKMALE.filter(function (x) { return t.indexOf(x) >= 0; });
    if (hat(t, VEGI)) m.push("vegi");
    if (hat(t, FISCH)) m.push("fisch");
    return m;
  }

  /* Familie für die Abwechslung, eine je Gericht, in dieser Reihenfolge: Vegetarisch/Vegan, Fisch, Low-Carb/Keto, Leicht/Abnehmen, Klassiker. */
  function familie(tags) {
    var t = tagListe(tags);
    if (hat(t, VEGI)) return "vegi";
    if (hat(t, FISCH)) return "fisch";
    if (hat(t, LOW)) return "low";
    if (t.indexOf("abnehmen") >= 0) return "leicht";
    return "klassiker";
  }

  function tagsVon(tagMap, handle) { return tagMap && Object.prototype.hasOwnProperty.call(tagMap, handle) ? tagMap[handle] : null; }

  /* Profil aus den Zeilen von /cart.js. tagMap: {handle: [tags]}. Es zählen nur Gerichte (Tag «hauptgerichte») mit bekannten Tags;
     Kühltasche, Extras, Geschenkkarte und Zeilen ohne Tags fallen weg. Gibt {anzahl, vegan, vegi, low, merkmale, familie, klar} zurück. */
  function profil(items, tagMap) {
    var gerichte = [];
    ((items) || []).forEach(function (i) {
      var t = tagsVon(tagMap, i && i.handle);
      if (t && hat(tagListe(t), GERICHT)) gerichte.push(tagListe(t));
    });
    var p = { anzahl: gerichte.length, vegan: false, vegi: false, low: false, merkmale: [], familie: null, klar: false };
    if (!gerichte.length) return p;
    p.vegan = gerichte.every(function (t) { return t.indexOf("vegan") >= 0; });
    p.vegi = gerichte.every(function (t) { return hat(t, VEGI); });
    p.low = gerichte.every(function (t) { return hat(t, LOW); });
    var gemeinsam = merkmale(gerichte[0]);
    gerichte.slice(1).forEach(function (t) { var m = merkmale(t); gemeinsam = gemeinsam.filter(function (x) { return m.indexOf(x) >= 0; }); });
    p.merkmale = gemeinsam;
    var f = familie(gerichte[0]);
    p.familie = gerichte.every(function (t) { return familie(t) === f; }) ? f : null;
    p.klar = p.vegi || p.low || !!p.familie;
    return p;
  }

  /* Harte Regeln: darf dieses Gericht zum Profil vorgeschlagen werden? Erlaubnisliste und Sperrliste zusammen: ein Gericht ohne passenden
     Tag (z. B. Lasagne ohne «high-carb») kommt bei einem Low-Carb-Warenkorb nicht hinein, ein widersprüchlich getaggtes (vegi und Fisch,
     low-carb und high-carb) auch nicht. */
  function erlaubt(tags, p) {
    if (!p) return true;
    var t = tagListe(tags);
    if (p.vegan && t.indexOf("vegan") < 0) return false;
    if (p.vegi && (!hat(t, VEGI) || hat(t, FISCH) || hat(t, FLEISCH))) return false;
    if (p.low && (!hat(t, LOW) || t.indexOf("high-carb") >= 0)) return false;
    return true;
  }

  /* Punkte: Anzahl gemeinsamer Merkmale mit dem Profil (Ernährung, Ziel, Protein). */
  function punkte(tags, p) {
    if (!p || !p.merkmale.length) return 0;
    var m = merkmale(tags);
    return p.merkmale.filter(function (x) { return m.indexOf(x) >= 0; }).length;
  }

  /* Reihenfolge eines Vorrats zum Profil. liste: Einträge mit tags, schon ohne was im Warenkorb liegt. Klares Profil: was die harten Regeln
     erlauben, nach Punkten, bei Gleichstand in der Reihenfolge der Liste. Kein klares Profil: je Familie das erste, dann der Rest. Stabil. */
  function ordnen(liste, p) {
    var l = (liste || []).filter(function (x) { return erlaubt(x.tags, p); });
    if (p && p.klar) {
      return l.map(function (x, i) { return { x: x, i: i, pt: punkte(x.tags, p) }; })
        .sort(function (a, b) { return (b.pt - a.pt) || (a.i - b.i); })
        .map(function (o) { return o.x; });
    }
    var vorne = [], rest = [], schon = {};
    l.forEach(function (x) {
      var f = familie(x.tags);
      if (schon[f]) rest.push(x); else { schon[f] = true; vorne.push(x); }
    });
    return vorne.concat(rest);
  }

  function hatGroesse(p) { return (p.varianten || []).some(function (v) { return v.available !== false && groesseIndex(v.title) >= 0; }); }

  /* Gerichte-Vorschläge. pool: [{handle, title, varianten:[…], bild, tags}] in der gewünschten Reihenfolge (Kollektion von Hand sortiert
     oder Bestseller). opt.ersatz: zweiter Vorrat zum Auffüllen (Bestseller, kommt immer hinter den ersten), opt.ohne: Handles, die nie für
     die Grösse zählen, opt.tags: {handle: [tags]} der Gerichte im Warenkorb (Profil). Was schon im Warenkorb liegt, fällt weg; doppelte
     Handles zählen einmal. Gibt höchstens n Einträge {handle, title, bild, variante, preis, groesse, marke} zurück (nie nach Preis). */
  function gerichtVorschlaege(pool, cart, n, gerichtHandles, opt) {
    var l = lage(cart, opt && opt.b2b);
    var imKorb = {};
    ((cart && cart.items) || []).forEach(function (i) { imKorb[i.handle] = true; });
    var ziel = zielGroesse(cart && cart.items, gerichtHandles, opt && opt.ohne);
    var sw = naechsteSchwelle(l);
    var p = profil(cart && cart.items, opt && opt.tags);
    var gesehen = {};
    function frei(liste) {
      return (liste || []).filter(function (x) {
        if (!x || !x.handle || gesehen[x.handle] || imKorb[x.handle] || !hatGroesse(x)) return false;
        gesehen[x.handle] = true;
        return true;
      });
    }
    var reihe = ordnen(frei(pool), p).concat(ordnen(frei(opt && opt.ersatz), p));
    return reihe.slice(0, n).map(function (x) {
      var v = waehleVariante(x.varianten, ziel);
      var preis = rappen(v.price);
      return {
        handle: x.handle, title: x.title, bild: x.bild, variante: v.id, preis: preis, groesse: String(v.title).trim(),
        marke: kreuzt(l, sw, preis) ? sw.text : ""
      };
    });
  }

  /* Reicht der Vorrat für n Karten, ohne was im Warenkorb liegt und ohne was die harten Regeln des Profils sperren?
     Sonst lädt assets/vf-warenkorb.js einmal die Bestseller zum Auffüllen. tagMap wie opt.tags. */
  function brauchtErsatz(pool, cart, n, tagMap) {
    var imKorb = {};
    ((cart && cart.items) || []).forEach(function (i) { imKorb[i.handle] = true; });
    var p = profil(cart && cart.items, tagMap);
    var frei = (pool || []).filter(function (x) { return x && !imKorb[x.handle] && hatGroesse(x) && erlaubt(x.tags, p); });
    return frei.length < n;
  }

  /* Extras-Vorschläge. pool: [{handle, title, varianten:[…], bild, groesse}]. Zuerst, was nicht im Warenkorb liegt. */
  function extraVorschlaege(pool, cart, n) {
    var imKorb = {};
    ((cart && cart.items) || []).forEach(function (i) { imKorb[i.handle] = true; });
    var kand = [];
    (pool || []).forEach(function (p) {
      var v = (p.varianten || []).filter(function (x) { return x.available !== false; })[0];
      if (!v) return;
      kand.push({ handle: p.handle, title: p.title, bild: p.bild, variante: v.id, preis: rappen(v.price), groesse: p.groesse || String(v.title || "").trim(), marke: "", drin: !!imKorb[p.handle], reihenfolge: p.reihenfolge });
    });
    kand.sort(function (a, b) { return (a.drin - b.drin) || (a.reihenfolge || 0) - (b.reihenfolge || 0); });
    return kand.slice(0, n);
  }

  /* Welche Karten stehen im Bereich «Hast Du etwas vergessen?». art: «seite» (3 + 1) oder «korb» (Mini-Warenkorb). */
  function empfehlungen(art, gerichte, extras, cart, gerichtHandles, opt) {
    var l = lage(cart, opt && opt.b2b);
    if (l.leer) return { karten: [], modus: "leer" };
    if (art === "korb") {
      return { modus: "korb", karten: gerichtVorschlaege(gerichte, cart, 4, gerichtHandles, opt).map(function (k) { return mitTyp(k, "gericht"); }) };
    }
    var hatExtras = !!(extras && extras.length);
    if (!hatExtras) { /* Extras fehlen (Kollektion nicht ladbar): vier Gerichte statt der Extras-Karte */
      return { modus: "gerichte", karten: gerichtVorschlaege(gerichte, cart, 4, gerichtHandles, opt).map(function (k) { return mitTyp(k, "gericht"); }) };
    }
    if (l.vor < EXTRAS_AB) {
      var g = gerichtVorschlaege(gerichte, cart, 3, gerichtHandles, opt).map(function (k) { return mitTyp(k, "gericht"); });
      var karten = g.slice(0, 1).concat([{ typ: "extras" }], g.slice(1));
      return { modus: "gerichte", karten: karten };
    }
    var e = extraVorschlaege(extras, cart, 3).map(function (k) { return mitTyp(k, "extra"); });
    var einGericht = gerichtVorschlaege(gerichte, cart, 1, gerichtHandles, opt).map(function (k) { return mitTyp(k, "gericht"); });
    return { modus: "extras", karten: e.concat(einGericht) };
  }

  function mitTyp(k, typ) { var o = {}; Object.keys(k).forEach(function (x) { o[x] = k[x]; }); o.typ = typ; return o; }

  /* products.json einer Kollektion in die interne Form bringen. */
  function ausProdukten(json, nurTag) {
    var list = (json && json.products) || [];
    var out = [];
    list.forEach(function (p, idx) {
      var tags = p.tags;
      if (typeof tags === "string") tags = tags.split(",").map(function (t) { return t.trim(); });
      tags = tags || [];
      if (nurTag && tags.indexOf(nurTag) < 0) return;
      var varianten = (p.variants || []).map(function (v) { return { id: v.id, title: v.title, price: v.price, available: v.available }; });
      var bild = p.images && p.images[0] && p.images[0].src ? p.images[0].src : "";
      out.push({ handle: p.handle, title: p.title, varianten: varianten, bild: bild, tags: tags, reihenfolge: idx });
    });
    return out;
  }

  /* Saucen sind immer derselbe Becher; Portionsnamen sind nur Richtwerte für die Nährwerte. */
  function extraGroesse(p) {
    if (p.tags && p.tags.indexOf("sauce_hausgemacht") >= 0) return "Becher à 250 g";
    var v = (p.varianten || [])[0];
    return v && v.title && v.title !== "Default Title" ? String(v.title).trim() : "";
  }

  function geldText(r) { return "CHF " + (r / 100).toFixed(2); }

  /* Termin-Karte: «Montag, 19.10.2026» aus dd/mm/yyyy, der Form des Liefertermin-Blocks (assets/vf-liefertermin.js; Wochentag aus dem
     Datum gerechnet, nie aus dem Attribut «Liefertag»). Kein echtes Kalenderdatum (z. B. 31/02/2026): nur die Schweizer Schreibweise mit
     Punkten. Alles andere (leer, fremder Text): "" = kein Datum. */
  var WOCHENTAGE = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
  function wochentagDatum(text) {
    var m = String(text || "").trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!m) return "";
    var j = +m[3], mo = +m[2], t = +m[1], d = new Date(Date.UTC(j, mo - 1, t));
    if (d.getUTCFullYear() !== j || d.getUTCMonth() !== mo - 1 || d.getUTCDate() !== t) return m[1] + "." + m[2] + "." + m[3];
    return WOCHENTAGE[d.getUTCDay()] + ", " + (t < 10 ? "0" : "") + t + "." + (mo < 10 ? "0" : "") + mo + "." + j;
  }

  /* Warenkorb leeren in zwei Schritten: «Wirklich leeren?» wird erst nach SPERRE_S Sekunden aktiv. */
  var SPERRE_S = 3;
  var ZURUECK_S = 6; /* ohne Tipp springt es danach zurück */
  function leerenSchritt(zustand, ereignis) {
    var z = zustand || { phase: "ruhe", rest: 0 };
    if (ereignis === "start") return { phase: "sperre", rest: SPERRE_S };
    if (ereignis === "tick" && z.phase === "sperre") return z.rest - 1 <= 0 ? { phase: "bereit", rest: 0 } : { phase: "sperre", rest: z.rest - 1 };
    if (ereignis === "zurueck" || ereignis === "abbruch") return { phase: "ruhe", rest: 0 };
    return z;
  }
  function leerenDarfLoeschen(zustand) { return !!zustand && zustand.phase === "bereit"; }

  var api = {
    GROESSEN: GROESSEN, schwellen: schwellen, EXTRAS_AB: EXTRAS_AB, SPERRE_S: SPERRE_S, ZURUECK_S: ZURUECK_S,
    rappen: rappen, lage: lage, kundenrabatt: kundenrabatt, naechsteSchwelle: naechsteSchwelle, kreuzt: kreuzt, zielGroesse: zielGroesse,
    waehleVariante: waehleVariante, gerichtVorschlaege: gerichtVorschlaege, profil: profil, erlaubt: erlaubt, familie: familie,
    merkmale: merkmale, punkte: punkte, ordnen: ordnen, brauchtErsatz: brauchtErsatz, extraVorschlaege: extraVorschlaege,
    empfehlungen: empfehlungen, ausProdukten: ausProdukten, extraGroesse: extraGroesse, geldText: geldText,
    wochentagDatum: wochentagDatum, leerenSchritt: leerenSchritt, leerenDarfLoeschen: leerenDarfLoeschen
  };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else root.VFWK = api;
})(typeof window !== "undefined" ? window : globalThis);
